import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import * as Sentry from '@sentry/angular';
import { BrowserTracing } from '@sentry/tracing';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  Sentry.init({
    dsn: 'https://7a081f44d41c4320a40458105918c8fe@o939397.ingest.sentry.io/4504136873279488',
    integrations: [
      new BrowserTracing({
        tracingOrigins: [
          'https://form-benefits.acessorh.com.br',
          'https://dev-form-benefits.acessorh.com.br',
          'https://dev-form.acessorh.com.br/svc2',
          'https://form.acessorh.com.br/svc2'
        ],
        routingInstrumentation: Sentry.routingInstrumentation
      })
    ],
    tracesSampleRate: 0.01
  });
}


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then()
  .catch(err => console.error(err));
